import { useState } from 'react'
import classNames from 'classnames'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'

import { ReactComponent as Op36Logo } from '../assets/images/logos/horizontal-logo.svg'
import backgroundVideo from './../assets/videos/welcome-page-background-video.mp4'
import backgroundVideoPoster from './../assets/images/welcome-page-background-video-poster.webp'
import { buildStateFromParams } from '../constants/oauth'
import { fetchIdpAuthorizationUrl, fetchIdpSignUpUrl } from '../actions/authActions'
import ButtonLink from './common/buttons/ButtonLink'
import buttonLinkStyles from './common/buttons/ButtonLink.module.scss'
import AccountSegmentSelector from './auth/common/AccountSegmentSelector'
import PrivacyTermsFooter from './auth/common/PrivacyTermsFooter'

import classes from './WelcomePage.module.scss'

const WelcomePage = () => {
  const communityId = localStorage.getItem('communityId')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [showSignUpSegmentSelector, setShowSignUpSegmentSelector] = useState(false)

  const handleSignIn = (e) => {
    e.preventDefault()
    fetchIdpAuthorizationUrl()
      .then(url => {
        const state = buildStateFromParams(null, communityId, searchParams)
        window.location.href = `${url}&state=${encodeURIComponent(state)}`
      })
      .catch(() => navigate('/login/legacy'))
  }

  const handleSignUp = (segment) => {
    fetchIdpSignUpUrl()
      .then(url => {
        const state = buildStateFromParams(segment, communityId, searchParams)
        window.location.href = `${url}&state=${encodeURIComponent(state)}`
      })
      .catch(() => toast.error('Sign up is currently unavailable.'))
  }

  const handleIndividualSignUp = () => handleSignUp('individual')
  const handleFamilySignUp = () => handleSignUp('family')

  return (
    <main className={classes.welcomePage}>
      <section className={classNames(classes.actionPanel, 'd-flex flex-column align-items-center')}>
        <div className={classNames(classes.mobileView, 'flex-column align-items-center w-100')}>
          <Op36Logo className={classes.op36Logo} />
          <h2 className={classNames(classes.logoText, 'mt-3')}>The #1 Way To Learn To Play Golf</h2>

          <ButtonLink navigateTo='sign-up/oauth' className={classNames(classes.actionLink, 'mt-4')}>
            Create an Account
          </ButtonLink>

          <ButtonLink linkColor='white' navigateTo='#' onClick={handleSignIn} className={classNames(classes.actionLink, 'mt-3')} isExternal>
            Log In
          </ButtonLink>

          <p className={classNames(classes.poweredByText, 'my-3')}>
            Powered by{' '}
            <a href='https://www.golfgenius.com' target='_blank' rel='noreferrer' className={classes.poweredByLink}>
              Golf Genius
            </a>
            {' '}secure login
          </p>
        </div>

        <div className={classNames(classes.desktopView, 'flex-column align-items-center')}>
          <Op36Logo className={classes.op36Logo} />
          <h2 className={classNames(classes.logoText, 'mt-3')}>The #1 Way To Learn To Play Golf</h2>

          {!showSignUpSegmentSelector ? (
            <>
              <button
                type='button'
                onClick={() => setShowSignUpSegmentSelector(true)}
                className={classNames(buttonLinkStyles['button-link'], buttonLinkStyles.orange, classes.actionLink, 'w-100 mt-4')}
              >
                Create an Account
              </button>

              <ButtonLink linkColor='white' navigateTo='#' onClick={handleSignIn} className={classNames(classes.actionLink, 'mt-3')} isExternal>
                Log In
              </ButtonLink>

              <p className={classNames(classes.poweredByText, 'mt-3 mb-0')}>
                Powered by{' '}
                <a href='https://www.golfgenius.com' target='_blank' rel='noreferrer' className={classes.poweredByLink}>
                  Golf Genius
                </a>
                {' '}secure login
              </p>
            </>
          ) : (
            <>
              <h5 className={classNames(classes.signUpTitle, 'w-100 mt-3')}>
                Let&apos;s get to know you...
                <br />
                Which describes you best?
              </h5>

              <AccountSegmentSelector
                onIndividualClick={handleIndividualSignUp}
                onFamilyClick={handleFamilySignUp}
                wrapperClassName='mb-3'
              />

              <PrivacyTermsFooter />
            </>
          )}
        </div>
      </section>

      <ToastContainer theme='colored' />

      <aside className={classes.heroPanel}>
        <div className={classes.heroPanelWrapper}>
          <video autoPlay loop muted poster={backgroundVideoPoster} className={classes.backgroundVideo}>
            <source src={backgroundVideo} type='video/mp4' />
          </video>

          <div className={classes.gradientOverlay} />
        </div>
      </aside>
    </main>
  )
}

export default WelcomePage
